import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { UserProfile } from '../types';
import { toast } from 'react-hot-toast';

export function useProfessionals() {
  const [professionals, setProfessionals] = useState<UserProfile[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('name'));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const professionalsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as UserProfile[];
      
      setProfessionals(professionalsData);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const addProfessional = async (professionalData: Omit<UserProfile, 'id' | 'createdAt' | 'updatedAt'>) => {
    try {
      const now = new Date().toISOString();
      await addDoc(collection(db, 'users'), {
        ...professionalData,
        createdAt: now,
        updatedAt: now
      });
      toast.success('Profissional cadastrado com sucesso!');
    } catch (error) {
      console.error('Erro ao cadastrar profissional:', error);
      toast.error('Erro ao cadastrar profissional');
      throw error;
    }
  };

  const updateProfessional = async (id: string, professionalData: Partial<UserProfile>) => {
    try {
      await updateDoc(doc(db, 'users', id), {
        ...professionalData,
        updatedAt: new Date().toISOString()
      });
      toast.success('Profissional atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar profissional:', error);
      toast.error('Erro ao atualizar profissional');
      throw error;
    }
  };

  const deleteProfessional = async (id: string) => {
    try {
      await deleteDoc(doc(db, 'users', id));
      toast.success('Profissional removido com sucesso!');
    } catch (error) {
      console.error('Erro ao remover profissional:', error);
      toast.error('Erro ao remover profissional');
      throw error;
    }
  };

  return {
    professionals,
    loading,
    addProfessional,
    updateProfessional,
    deleteProfessional
  };
}